module.exports = __webpack_public_path__ + "static/media/KurtHengel.1f0ee196.jpg";